import { atom } from "jotai";

export interface OpinionHeader {
  isShowingOpinionHeaderContainer: boolean;
}

export const opinionHeaderAtom = atom<OpinionHeader>({
  isShowingOpinionHeaderContainer: false,
});
